import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface SupportContext {
  user: {
    id: number;
    name: string;
    email: string;
    phone_number: string;
    identifier: string;
    identity_hash: string;
  };
  organization: {
    id: number;
    name: string;
  };
  unit: {
    id: number;
    name: string;
  };
  reseller: {
    id: number | null;
    name: string | null;
  };
  chatwoot: {
    base_url: string;
    website_token: string;
  };
}

export interface ResellerContact {
  tel_phone: string | null;
  cel_phone: string | null;
  email: string | null;
  website: string | null;
}

export interface SupportRouting {
  support_type: 'chatwoot' | 'contact' | 'none';
  chatwoot_base_url: string | null;
  chatwoot_website_token: string | null;
  reseller_id: number | null;
  reseller_name: string | null;
  contact: ResellerContact | null;
}

@Injectable({
  providedIn: 'root',
})
export class SupportApiService {
  constructor(private http: HttpClient) {}

  getContext(): Observable<SupportContext> {
    return this.http.get<SupportContext>('/api/support/context/');
  }

  getRouting(params?: { reseller_id?: string; email?: string; unit_hash?: string }): Observable<SupportRouting> {
    return this.http.get<SupportRouting>('/api/support/routing/', { params: params as any });
  }
}
